module.exports = __webpack_public_path__ + "static/media/camera_light.2caa0019.svg";